// ================================================================================
// ie11.js
// IE11 用のスクリプトファイル
// ================================================================================

import cssVars from 'css-vars-ponyfill';

if (navigator.userAgent.indexOf('msie') >= 0 || navigator.userAgent.indexOf('Trident') >= 0){
	cssVars({
		// Targets
		rootElement   : document,
		shadowDOM     : false,

		// Sources
		include       : 'link[rel=stylesheet],style',
		exclude       : '',
		variables     : {},

		// Options
		onlyLegacy    : !(/IE\/11\./i.test(navigator.userAgent)),
		preserveStatic: true,
		preserveVars  : false,
		silent        : false,
		updateDOM     : true,
		updateURLs    : true,
		watch         : false,
		variables: {
			'--global--font-size-2xs' : '1.1rem',
			'--global--font-size-xs' : '1.3rem',
			'--global--font-size-sm' : '1.4rem',
			'--global--font-size-md' : '1.6rem',
			'--global--font-size-lg' : '1.8rem',
			'--global--font-size-xl' : '2.1rem',
			'--global--font-size-2xl' : '2.6rem',
			'--global--font-size-3xl' : '3.2rem',
			'--global--spacing-content' : '2.2rem',
			'--aligndefault-width' : '90rem',
			'--alignwide-width' : '120rem',
			'--inner-width' : 'calc( 106rem + var(--global--spacing-content) * 2 )',
			'--max-content-width' : 'calc( 128rem + var(--global--spacing-content) * 2 )'
		}
	});

}
